import api from '@/api'

export default {
  async getFiles({ commit, state }, path) {
    return new Promise((resolve, reject) => {
      api.getFiles(path)
        .then(response => {
          commit('SET_FILES', response.data)
          resolve(response)
        })
    })
  },
  async getBase64File({ commit, state }, file) {
    return new Promise((resolve, reject) => {
      api.getBase64File(file)
        .then(response => {
          commit('SET_FILE', response.data)
          resolve(response)
        })
    })
  },
  async getThumbs({ commit, state }, path) {
    return new Promise((resolve, reject) => {
      api.getThumbs(path)
        .then(response => {
          commit('SET_THUMBS', response.data)
          resolve(response)
        })
    })
  },
  async uploadBase64File({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.uploadBase64File(data)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/files/actions.js